import { FC } from 'react';

import { ArrowIcon, HighFiveHandsIcon } from 'assets';
import { Button } from 'view/components';
import * as S from 'view/modals/OnboardingWizard/styled';

interface IntroStepProps {
  onNext: () => void;
  onBack: () => void;
}

const JobSeekerIntroStep: FC<IntroStepProps> = ({ onNext, onBack }) => {
  return (
    <S.WizardContent>
      <S.StepImage>
        <HighFiveHandsIcon />
      </S.StepImage>
      <S.StepHeader>
        <S.StepTitle>Let&apos;s Build Your Profile</S.StepTitle>
        <S.StepSubtitle
          style={{
            maxWidth: 374,
          }}
        >
          Your profile highlights your skills, experience, and potential to match you with the right
          opportunities
        </S.StepSubtitle>
      </S.StepHeader>
      <S.WizardFooter>
        <Button variant="outlined" text="Back" onClick={onBack} />
        <Button
          variant="contained"
          text="Set up profile"
          onClick={onNext}
          endIcon={<ArrowIcon rotate="right" color="#FFFFFF" />}
        />
      </S.WizardFooter>
    </S.WizardContent>
  );
};

export default JobSeekerIntroStep;
